var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpdatedMergeBoardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.31195 17.8849L10.1368 12.4246H18.9577L16.4736 14.9161C16.3094 15.0808 16.3094 15.3506 16.4736 15.5152C16.6376 15.6798 16.9067 15.6798 17.0708 15.5152L20.2769 12.2995C20.441 12.135 20.441 11.865 20.2769 11.7005L17.0708 8.48481C16.9067 8.32025 16.6376 8.32025 16.4736 8.48481C16.3094 8.64938 16.3094 8.91927 16.4736 9.08384L18.9577 11.5754H10.1368L4.31195 6.11503C4.1413 5.95376 3.87221 5.96363 3.7147 6.13478C3.55718 6.30594 3.56374 6.57583 3.73438 6.73381L9.35249 12L3.73439 17.2662C3.56374 17.4275 3.5539 17.6941 3.7147 17.8652C3.8755 18.0364 4.1413 18.0462 4.31195 17.8849Z",
    fill: "#C6CED7",
    stroke: "#C6CED7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdatedMergeBoardIcon);
export default __webpack_public_path__ + "static/media/updated_merge_board_icon.175e916483dda79b9069ed6d8ed5e889.svg";
export { ForwardRef as ReactComponent };